import { ADD_PACKAGE_LISTS } from '../actions/type';

const initState = {
   packages:[]
}

const packageLists = (state = initState, action) => {
    switch (action.type) {
        case ADD_PACKAGE_LISTS:
            const payload = action.payload;
            return { ...state, ...payload };
        default:
            return state;
    }
}

export default packageLists